import Count                                   from "../../../../domain/fundamentals/count/Count";
import ReservationCancelStatusRepository       from "../../../../domain/reservation/cancel/ReservationCancelStatusRepository";
import { apiGetReservationCancelRequestCount } from "../../../api/reservation/cancel";

class ReservationCancelStatusDataSource implements ReservationCancelStatusRepository {
  countRequestedBy(): Promise<Count> {
    return apiGetReservationCancelRequestCount();
  }

}

export default ReservationCancelStatusDataSource;
